export function calculateAerobicTrainingZones(css = 1, velocity = 100) {
    const velocityValue = Number.parseFloat(velocity);
    const cssValue = Number.parseFloat(css);
    let calc;
    switch (velocityValue) {
        case 100:
            calc = {
                rec: {
                    timeFrom: 0,
                    timeTo: 0.94,
                    averagePace: 0.94
                },
                end1: {
                    timeFrom: 0.95,
                    timeTo: 0.97,
                    averagePace: 0.96
                },
                end2: {
                    timeFrom: 0.98,
                    timeTo: 1.0,
                    averagePace: 0.99
                },
                end3: {
                    timeFrom: 1.01,
                    timeTo: 1.04,
                    averagePace: 1.025
                }
            };
            break;
        case 200:
            calc = {
                rec: {
                    timeFrom: 0,
                    timeTo: 0.92,
                    averagePace: 0.92
                },
                end1: {
                    timeFrom: 0.93,
                    timeTo: 0.95,
                    averagePace: 0.94
                },
                end2: {
                    timeFrom: 0.96,
                    timeTo: 0.98,
                    averagePace: 0.97
                },
                end3: {
                    timeFrom: 0.99,
                    timeTo: 1.02,
                    averagePace: 1.005
                }
            };
            break;
        case 300:
            calc = {
                rec: {
                    timeFrom: 0,
                    timeTo: 0.91,
                    averagePace: 0.91
                },
                end1: {
                    timeFrom: 0.92,
                    timeTo: 0.94,
                    averagePace: 0.93
                },
                end2: {
                    timeFrom: 0.95,
                    timeTo: 0.97,
                    averagePace: 0.96
                },
                end3: {
                    timeFrom: 0.98,
                    timeTo: 1.01,
                    averagePace: 0.995
                }
            };
            break;
        case 400:
            calc = {
                rec: {
                    timeFrom: 0,
                    timeTo: 0.9,
                    averagePace: 0.9
                },
                end1: {
                    timeFrom: 0.91,
                    timeTo: 0.93,
                    averagePace: 0.92
                },
                end2: {
                    timeFrom: 0.94,
                    timeTo: 0.96,
                    averagePace: 0.95
                },
                end3: {
                    timeFrom: 0.97,
                    timeTo: 1.0,
                    averagePace: 0.985
                }
            };
            break;
        default:
            calc = null;
    }

    return {
        zone1: {
            title: 'Rec',
            subTitle: 'Over Distance',
            timeFrom: '<',
            timeTo: formatSecondsToTimeString(100 / (cssValue * calc.rec.timeTo)),
            averagePace: formatSecondsToTimeString(100 / (cssValue * calc.rec.averagePace)),
            totalDuration:
                velocityValue === 100
                    ? null
                    : formatSecondsToTimeString(
                          ((100 / (cssValue * calc.rec.averagePace)) * velocityValue) / 100
                      )
        },
        zone2: {
            title: 'End 1',
            subTitle: 'Basic Aerobic',
            timeFrom: formatSecondsToTimeString(100 / (cssValue * calc.end1.timeFrom)),
            timeTo: formatSecondsToTimeString(100 / (cssValue * calc.end1.timeTo)),
            averagePace: formatSecondsToTimeString(100 / (cssValue * calc.end1.averagePace)),
            totalDuration:
                velocityValue === 100
                    ? null
                    : formatSecondsToTimeString(
                          ((100 / (cssValue * calc.end1.averagePace)) * velocityValue) / 100
                      )
        },
        zone3: {
            title: 'End 2',
            subTitle: 'Lactate Threshold',
            timeFrom: formatSecondsToTimeString(100 / (cssValue * calc.end2.timeFrom)),
            timeTo: formatSecondsToTimeString(100 / (cssValue * calc.end2.timeTo)),
            averagePace: formatSecondsToTimeString(100 / (cssValue * calc.end2.averagePace)),
            totalDuration:
                velocityValue === 100
                    ? null
                    : formatSecondsToTimeString(
                          ((100 / (cssValue * calc.end2.averagePace)) * velocityValue) / 100
                      )
        },
        zone4: {
            title: 'End 3',
            subTitle: 'Vo2max',
            timeFrom: formatSecondsToTimeString(100 / (cssValue * calc.end3.timeFrom)),
            timeTo: formatSecondsToTimeString(100 / (cssValue * calc.end3.timeTo)),
            averagePace: formatSecondsToTimeString(100 / (cssValue * calc.end3.averagePace)),
            totalDuration:
                velocityValue === 100
                    ? null
                    : formatSecondsToTimeString(
                          ((100 / (cssValue * calc.end3.averagePace)) * velocityValue) / 100
                      )
        }
    };
}

export function calculateAnaerobicTrainingZones(mss = 1, velocity = 50) {
    const velocityValue = Number.parseFloat(velocity);
    const mssValue = Number.parseFloat(mss);

    return {
        zone1: {
            title: 'Sp 1',
            subTitle: 'Lactate Tolerance',
            timeFrom: formatSecondsToTimeString(velocityValue / (mssValue * 0.9)),
            timeTo: formatSecondsToTimeString(velocityValue / (mssValue * 0.95)),
            averagePace: formatSecondsToTimeString(velocityValue / (mssValue * 0.925))
        },
        zone2: {
            title: 'Sp 2',
            subTitle: 'Produce Lactate',
            timeFrom: formatSecondsToTimeString(velocityValue / (mssValue * 0.95)),
            timeTo: formatSecondsToTimeString(velocityValue / (mssValue * 1.0)),
            averagePace: formatSecondsToTimeString(velocityValue / (mssValue * 0.975))
        },
        zone3: {
            title: 'Sp 3',
            subTitle: 'Max Speed & Power',
            timeFrom: formatSecondsToTimeString(velocityValue / (mssValue * 1.0)),
            timeTo: formatSecondsToTimeString(velocityValue / (mssValue * 1.1)),
            averagePace: formatSecondsToTimeString(velocityValue / (mssValue * 1.05))
        }
    };
}

function formatSecondsToTimeString(seconds) {
    if (isNaN(seconds)) return '';
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    const ms = Math.round((seconds - Math.floor(seconds)) * 1000);
    return (
        String(min).padStart(2, '0') +
        ':' +
        String(sec).padStart(2, '0') +
        ',' +
        String(ms).padStart(3, '0')
    );
}
